export default class GeraisData {
  cliente = null;
  tecnico = null;
  data_manutencao = null;
  objeto = null;
  constructor(
    cliente = null,
    tecnico = null,
    data_manutencao = null,
    objeto = null,
  ) {
    this.cliente = cliente;
    this.data_manutencao = data_manutencao;
    this.tecnico = tecnico;
    this.objeto = objeto;
  }
}